import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');

let dashboardPages = {
  path: '/',
  component: DashboardLayout,
  redirect: '/dashboard',
  name: 'DashboardLayout',
  meta: { title: 'Inicio', auth: true },
  children: [
    {
      path: 'dashboard',
      name: 'Dashboard',
      meta: {
        title: 'Panel de Control',
      },
      component: Dashboard,
    },
  ],
};

import authPages from './pages/auth.pages';
import articlesPages from './pages/articles.pages';
import campaignsPages from './pages/campaigns.pages';
// import contactsPages from './pages/contacts.pages';
import cropsPages from './pages/crops.pages';
import distributorsPages from './pages/distributors.pages';
import fieldsPages from './pages/fields.pages';
import ordersPages from './pages/orders.pages';
import plotsPages from './pages/plots.pages';
import producersPages from './pages/producers.pages';
import rolesPages from './pages/roles.pages';
import sellersPages from './pages/sellers.pages';
import usersPages from './pages/users.pages';
import varietiesPages from './pages/varieties.pages';
import visitsPages from './pages/visits.pages';
import documentsPages from './pages/documents.pages';
import projectionsPages from './pages/projections.pages';
import quotationsPages from './pages/quotations.pages';
import dollarQuotationsPages from './pages/dollar-quotations.pages';
import deliveryNotesPages from './pages/delivery-notes.pages';
import stockPages from './pages/stocks.pages';
import receiptsPages from './pages/receipts.pages';
import conceptPaymentTypes from './pages/concept-payment-types.pages';

const routes = [
  { path: '/', redirect: '/dashboard' },
  // settings chunk
  conceptPaymentTypes,
  rolesPages,
  usersPages,
  campaignsPages,
  cropsPages,
  varietiesPages,
  // producers chunk
  receiptsPages,
  producersPages,
  fieldsPages,
  plotsPages,
  // admin chunk
  sellersPages,
  distributorsPages,
  documentsPages,
  projectionsPages,
  // contactsPages,
  // dashboard
  visitsPages,
  dashboardPages,
  // orders
  articlesPages,
  ordersPages,
  quotationsPages,
  dollarQuotationsPages,
  deliveryNotesPages,
  stockPages,
  // pages chunk
  //pagesMenu,
  authPages,
];

export default routes;
